// ===== Content Protection =====

// Disable keyboard shortcuts for DevTools, print, save, view-source
document.addEventListener("keydown", (e) => {
  // F12 - DevTools
  if (e.key === "F12") {
    e.preventDefault();
  }

  // Ctrl+Shift+I / Cmd+Shift+I - DevTools
  if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "I") {
    e.preventDefault();
  }

  // Ctrl+Shift+J / Cmd+Shift+J - Console
  if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "J") {
    e.preventDefault();
  }

  // Ctrl+Shift+C / Cmd+Shift+C - Inspect element
  if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "C") {
    e.preventDefault();
  }

  // Ctrl+U / Cmd+U - View source
  if ((e.ctrlKey || e.metaKey) && e.key === "u") {
    e.preventDefault();
  }

  // Ctrl+S / Cmd+S - Save page
  if ((e.ctrlKey || e.metaKey) && e.key === "s") {
    e.preventDefault();
  }

  // Ctrl+P / Cmd+P - Print
  if ((e.ctrlKey || e.metaKey) && e.key === "p") {
    e.preventDefault();
  }

  // Ctrl+Shift+K / Cmd+Shift+K - Console (Firefox)
  if ((e.ctrlKey || e.metaKey) && e.shiftKey && e.key === "K") {
    e.preventDefault();
  }
});

// Disable drag events on the entire document
document.addEventListener("dragstart", (e) => {
  e.preventDefault();
});

// Disable copy
document.addEventListener("copy", (e) => {
  e.preventDefault();
});

// Disable cut
document.addEventListener("cut", (e) => {
  e.preventDefault();
});

// Blank page on print attempt (backup for CSS @media print)
window.addEventListener("beforeprint", () => {
  document.body.style.display = "none";
});
window.addEventListener("afterprint", () => {
  document.body.style.display = "";
});
